var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",style:({bottom:_vm.height})},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"copyright"},[_vm._v(" 广州市番禺区钟村街汉溪村（汉溪商业中心）泽溪街9号1205"),_c('br'),_vm._v(" Copyright © 2008-2022 广州犇牛信息产业有限公司. 保留所有权利。 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("粤ICP备2024255360号")])])
}]

export { render, staticRenderFns }